/**
 * A régua como faixa de leitura: ✉ E-mail → 7 d → ✉ E-mail → 💬 WhatsApp.
 *
 * É o caminho principal do fluxo (a API já o linearizou), não o grafo — o
 * grafo é do canvas. Na listagem, o que distingue uma campanha da outra é a
 * cadência: quantos toques, em que canal, com que espaçamento. É isso que a
 * faixa mostra num relance.
 */

import type { PassoFluxo } from './tipos'

const NOME_CANAL: Record<string, string> = {
  email: 'E-mail',
  whatsapp: 'WhatsApp',
  sms: 'SMS',
}

function rotuloEspera(minutos?: number): string {
  if (!minutos) return 'espera'
  if (minutos % 1440 === 0) return `${minutos / 1440} d`
  if (minutos % 60 === 0) return `${minutos / 60} h`
  return `${minutos} min`
}

function Pilula({ passo }: { passo: PassoFluxo }) {
  switch (passo.tipo) {
    case 'gatilho':
      return (
        <span className="shrink-0 rounded-full bg-slate-100 px-2 py-0.5 text-[11px] font-medium text-slate-500">
          entrada
        </span>
      )
    case 'acao':
      return (
        <span
          className={`shrink-0 rounded-full px-2 py-0.5 text-[11px] font-semibold ${
            passo.canal === 'whatsapp'
              ? 'bg-emerald-50 text-emerald-700'
              : passo.canal === 'sms'
                ? 'bg-violet-50 text-violet-700'
                : 'bg-marca-50 text-marca-700'
          }`}
        >
          {NOME_CANAL[passo.canal ?? ''] ?? 'Ação'}
        </span>
      )
    case 'espera':
      return (
        <span className="shrink-0 rounded-full border border-dashed border-slate-300 px-2 py-0.5 text-[11px] text-slate-500 tabular">
          {rotuloEspera(passo.minutos)}
        </span>
      )
    case 'condicao':
      return (
        <span className="shrink-0 rounded-full bg-amber-50 px-2 py-0.5 text-[11px] font-medium text-amber-700">
          condição
        </span>
      )
    case 'divisao_ab':
      return (
        <span className="shrink-0 rounded-full bg-violet-50 px-2 py-0.5 text-[11px] font-medium text-violet-700">
          A/B
        </span>
      )
    case 'fim':
      return (
        <span className="shrink-0 rounded-full bg-slate-100 px-2 py-0.5 text-[11px] text-slate-400">
          fim
        </span>
      )
    default:
      return null
  }
}

export function FluxoRegua({ fluxo }: { fluxo: PassoFluxo[] }) {
  if (fluxo.length === 0) {
    return <p className="text-xs text-slate-400">Régua ainda vazia — desenhe o percurso.</p>
  }
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {fluxo.map((p, i) => (
        <span key={i} className="flex items-center gap-1.5">
          {i > 0 && (
            <span aria-hidden="true" className="text-slate-300">
              →
            </span>
          )}
          <Pilula passo={p} />
        </span>
      ))}
    </div>
  )
}
